import { useEffect, useState } from 'react';
import { Dropdown, Stack } from 'rsuite';
import PeoplesIcon from '@rsuite/icons/Peoples';
import { useAppDispatch, useAppSelector } from '@monorepo/shared';
import {
  selectHaCurrentGroup,
  selectHaGroups,
  updateHaCurrentGroup
} from '@monorepo/shared/store/groupSlice';
interface IProps {}
export const GroupDropdown = () => {
  const dispatch = useAppDispatch();
  const groups = useAppSelector(selectHaGroups);
  const currentHaGroup = useAppSelector(selectHaCurrentGroup);
  const onSelect = (item: any, event: any) => {
    dispatch(updateHaCurrentGroup(item));
  };

  useEffect(() => {}, [groups]);

  return Object.values(groups).length > 0 ? (
    <div className="group-dropdown">
      <Stack spacing={8}>
        <PeoplesIcon style={{ fontSize: '1.5em' }} />
        <Stack.Item grow={1}>
          <Dropdown
            appearance="default"
            size="sm"
            title={currentHaGroup?.desc}
            style={{ width: '100%' }}
          >
            {Object.values(groups).map(
              (obj: Record<string, any>, idx: number) => (
                <Dropdown.Item
                  style={{ padding: '10px 20px' }}
                  key={idx + 1}
                  onSelect={(e) => onSelect(obj, e)}
                  active={currentHaGroup?.id === obj?.id}
                >
                  {obj?.desc || obj?.name}
                </Dropdown.Item>
              )
            )}
          </Dropdown>
        </Stack.Item>
      </Stack>
    </div>
  ) : (
    <></>
  );
};

export default GroupDropdown;
